// src/pages/AiPage.js
import React, { useEffect } from "react";
import Layout from "../components/Layout";
import styles from "./AiPage.module.css";
import Button from "../components/Button";
import { useActivateHandler } from "../hooks/useActivateHandler";
import { sendMessageToParent } from "../utils/postMessage";
import { useSearchParams } from "react-router-dom";
import TurnVisitSection from "../components/TurnVisitSection";
import AiPoweredSection from "../components/AiPoweredSection";
import CouponSection from "../components/CouponSection";
import AutomateSection from "../components/AutomateSection";
import HowAiWorkSection from "../components/HowAiWorkSection";
import RevenueEngineSection from "../components/RevenueEngineSection";
import AiHeroSection from "../components/AiHeroSection";
import AiResult from "../components/AiResult";

const AiPage = () => {
  useEffect(() => {
    document.title = "Instant AI - Supercharge Your Business with AI";
  }, []);

  const { handleActivateClick, config } =
    useActivateHandler(sendMessageToParent);

  const [searchParams] = useSearchParams();

  // Get values from URL params with defaults
  // const conversionStat = searchParams.get('conversion') || 'Up to 10x';
  const revenueStat = searchParams.get("revenue") ? '$'+ searchParams.get("revenue") : "50-100%";
  const roiStat = searchParams.get("roi") ? searchParams.get("roi") + "x ROI" : "40x ROI";

     const handleNavigateClick = (url) => {
       sendMessageToParent('NAVIGATE_TO', {
         feature: 'ai',
         redirect: url,
         source: 'ai_landing_page'
       });
     };

  return (
    <Layout>
      <div className={`page ${styles.aiPage}`}>
        <AiHeroSection styles={styles} handleActivateClick={handleActivateClick} config={config}/>
        <hr />
        <RevenueEngineSection styles={styles} revenueStat={revenueStat} roiStat={roiStat}/>

        <div className={styles.stickybar}>
          <div className={styles.barContentContainer}>
            <p>Grow your business while Instant AI grows your revenue</p>
            <Button onClick={handleActivateClick}> {config.text} </Button>
          </div>
        </div>

        <HowAiWorkSection styles={styles}/> 
        <hr />
        <AutomateSection styles={styles}/>
        <AiPoweredSection styles={styles}/>
        <CouponSection styles={styles}/>
        <TurnVisitSection styles={styles}/>
        <AiResult handleNavigateClick={handleNavigateClick} styles={styles}/>
      
      </div>
    </Layout>
  );
};

export default AiPage;
